import api from "./axios";
import type { User } from "@/types";
import { ApiPath } from "@/constants/api-routes";

const apiRoot = `${process.env.API_URL || ""}/api`;

export const authApi = {
  getGoogleAuthUrl: () => `${apiRoot}${ApiPath.authGoogle()}`,

  logout: () => api.post(ApiPath.authLogout()).then((r) => r.data),

  getMe: () => api.get<User>(ApiPath.authMe()).then((r) => r.data),

  deleteAccount: () => api.delete(ApiPath.authMe()).then((r) => r.data),
};
